export default __webpack_public_path__ + "static/1783-5e95ccd8bb616d7761477163d58a44b8.gif";